import { IconButton } from "@mui/material"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useRef, useState } from "react"

import type { PaymentTerm } from "@/graphql/codegen/graphql"

const PaymentTermRowActions: FC<{ paymentTerm: PaymentTerm }> = ({ paymentTerm }) => {
  const navigate = useNavigate()

  const [menuOpen, setMenuOpen] = useState<boolean>(false)
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const handleEdit = () => {
    if (paymentTerm.paymentTermId) {
      navigate({ to: `/app/admin/accounting/payment-term/${paymentTerm.paymentTermId}` })
    }
  }

  return (
    <>
      <IconButton onClick={() => setMenuOpen(!menuOpen)} ref={anchorElRef}>
        <MoreVertOutlined />
      </IconButton>

      <Menu
        anchorEl={anchorElRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <EditOutlined className='text-gray-600' />
          </ListItemIcon>
          <ListItemText primary='Edit Payment Term' className='text-gray-800' />
        </MenuItem>
      </Menu>
    </>
  )
}

export default PaymentTermRowActions
